<template>
  <div>
    <div class="consent-education-3 common-consent-edu" v-if="!isEligibleToJoin && !isNotEligibleToJoin && currentQuestion">
      <p
        class="verify-name m-0 pb-48"
        v-translate:dynamic_string="{
          key: `${currentQuestion.identifier}_body`,
          val: lang,
          html: currentQuestion.body
        }"
      >
        {{ currentQuestion.body }}
      </p>

      <div v-if="currentQuestion.type == 'singleChoice'">
        <b-form-radio-group v-model="answer" @input="onAnswerClick(currentQuestion)" stacked ref="radioGroup">
          <b-form-radio class="light" v-for="(option, i) in currentQuestion.options" :key="i" :value="option.sequence">
            <span
              class="cursor-pointer wrap-option-text"
              v-translate:dynamic_string="{
                key: `${currentQuestion.identifier}_options_${i}_body`,
                val: lang,
                html: option.label ? option.label : option.body
              }"
              >{{ option.label ? option.label : option.body }}</span
            >
          </b-form-radio>
        </b-form-radio-group>
      </div>
      <div v-if="currentQuestion.type == 'boolean'">
        <div class="row edu-btn-group av-education-boolean-question">
          <div class="col-6 col-md-6" v-for="(question, index) in currentQuestion.options" :key="index">
            <button
              class="btn leavestudy"
              :class="{
                'leave_study_cntue primary-bg': answer === question.sequence
              }"
              @click="
                () => {
                  answer = question.sequence;
                  onAnswerClick(currentQuestion);
                }
              "
            >
              {{ booleanButtonTextTranslate(index, question.body) }}
            </button>
          </div>
        </div>
      </div>

      <div class="text-center pt-80 ml-15 mr-15">
        <button class="btn btn-submit primary-bg" :disabled="nextButtonDisabled" @click="nextConsentQuestion" v-translate:next_text="lang">
          Next
        </button>
      </div>
    </div>
    <div v-if="isEligibleToJoin">
      <div class="consent-education-4 common-consent-edu">
        <div class="text-center">
          <img src="@/assets/ICN - green check big.png" alt="" class="edu-green-check" />
        </div>
        <p class="verify-name m-0" v-translate:label_eligibility_greetings="lang">
          You are eligible to join this study.
        </p>
        <p class="pt-0 edu-consent-text" v-translate:label_eligibility_desc="lang">
          You are eligible to participate in this study. Tap the button below to be guided through the research activities and responsibilities.
        </p>
        <div class="text-center pt-16 ml-15 mr-15">
          <button class="btn btn-submit primary-bg" @click="updateConsentValue('updateConsentScreen','disclaimer')" v-translate:next_text="lang">
            Next
          </button>
        </div>
      </div>
    </div>
    <div v-if="isNotEligibleToJoin">
      <div class="consent-education-4 common-consent-edu">
        <div class="text-center">
          <img src="@/assets/ICN - red X.png" alt="" class="edu-green-check" />
        </div>
        <p class="verify-name m-0" v-translate:rsb_quiz_evaluation_try_again="lang">
          Try Again
        </p>
        <p class="edu-consent-text m-0" v-translate:failure_message="lang">
          Please read the description of the study again and repeat the test to verify your understanding.
        </p>
        <div class="text-center pt-42 ml-15 mr-15">
          <button class="btn btn-submit primary-bg" @click="updateConsentValue('wrongAnswer','education')" v-translate:rsb_quiz_evaluation_try_again="lang">
            Try Again
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Consent, Widget, ParticipantPortal, Participant } from "@/components/services/participant-service";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

export default {
  name: "join-concent-question",
  components: {},
  props: ["isOnBackClick", "lang", "currentConsent", "page"],
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      consent: new Consent(),
      participantDetails: new Participant(),
      isEligibleToJoin: false,
      isParticipantAgreed: false,
      isNotEligibleToJoin: false,
      initalConQuestionObjIndex: this.page,
      selectedQueAns: null,
      getConsentsQuiz: null,
      onBoardingData: [],
      allQuizAns: [],
      nextButtonDisabled: true,
      answer: ""
    };
  },
  computed: {
    ...mapGetters(["participant"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    currentQuestion() {
      if (this.consent) {
        this.updateConsentQuiz();
        return this.getConsentsQuiz.questions[this.initalConQuestionObjIndex];
      }
      return {};
    },
    getConsentID() {
      if (this.consent) {
        return this.consent.getCurrentConsentId();
      }
      return "";
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    getSiteID() {
      return this.study && this.study.sitesInfo[0] && this.study.sitesInfo[0].id;
    }
  },
  watch: {
    page(val) {
      this.initalConQuestionObjIndex = val;
    },
    isOnBackClick(val) {
      if (val) {
        if (this.initalConQuestionObjIndex == 0) {
          this.$emit("backButtonClick", "education");
        } else {
          this.previousQuestion();
        }
      }
    }
  },
  mounted() {
    this.$root.$emit("setHeaderOptions", { hideCancel: false });
  },
  methods: {
    updateConsentQuiz() {
      this.getConsentsQuiz = this.consent.getConcentQuestions();
      this.getConsentsQuiz.questions[this.initalConQuestionObjIndex].sequence = "";
    },
    booleanButtonTextTranslate(index, text) {
      let convertedText = text;
      if (index == 0) {
        convertedText = this.widget.translate("yes", text);
      } else {
        convertedText = this.widget.translate("no", text);
      }
      return convertedText;
    },
    onRadioAnswerClick(value, question) {
      this.nextButtonDisabled = false;
      this.currentQuestion.sequence = value;
      this.selectedQueAns = question;
    },
    onAnswerClick(question) {
      this.nextButtonDisabled = false;
      this.currentQuestion.sequence = this.answer;
      this.selectedQueAns = question;
    },
    nextConsentQuestion() {
      this.addConsentQuestion(this.selectedQueAns);
      if (this.getConsentsQuiz.questions.length === this.onBoardingData.length) {
        if (this.allQuizAns.length > 0) {
          const eligible = this.allQuizAns.reduce((status, item) => {
            if (status === false) {
              return false;
            } else {
              if (item.sequence !== item.expectedAnswer) {
                return false;
              } else {
                return true;
              }
            }
          }, true);

          if (eligible) {
            this.showSuccess();
          } else {
            this.showFailure();
          }
        }
      } else {
        this.onNextQuestion();
      }
    },
    showSuccess() {
      this.$root.$emit("setHeaderOptions", {
        hideBack: true,
        hideCancel: true
      });
      this.isEligibleToJoin = true;
    },
    showFailure() {
      this.$root.$emit("setHeaderOptions", {
        hideBack: true,
        hideCancel: true
      });
      this.isNotEligibleToJoin = true;
    },
    onNextQuestion() {
      if (this.getConsentsQuiz.questions.length > this.initalConQuestionObjIndex) {
        this.initalConQuestionObjIndex = this.initalConQuestionObjIndex + 1;
        this.initalConQuestionObjIndex = this.initalConQuestionObjIndex % this.getConsentsQuiz.questions.length;
        this.getConsentsQuiz.questions[this.initalConQuestionObjIndex].sequence = null;
        this.nextButtonDisabled = true;
        this.answer = "";
        this.$emit("pageChange", this.initalConQuestionObjIndex);
      }
    },
    previousQuestion() {
      if (this.initalConQuestionObjIndex >= 1) {
        this.initalConQuestionObjIndex = this.initalConQuestionObjIndex - 1;
        this.initalConQuestionObjIndex = this.initalConQuestionObjIndex % this.getConsentsQuiz.questions.length;
        this.nextButtonDisabled = true;
        this.answer = "";
        this.$emit("pageChange", this.initalConQuestionObjIndex);
      } else {
        this.$emit("updateConsentScreen", "prev-consent");
      }
    },
    addConsentQuestion() {
      let questionAnswers;
      const { type, identifier, body, sequence, options } = this.currentQuestion;
        const selectedAns = options.filter((option, i) => {
        if (option.sequence == sequence) {
          option.index = i;
          return option;
        }
      });
      if (selectedAns && selectedAns.length > 0 && type == "boolean") {
        questionAnswers = this.widget.translate(selectedAns[0].body == "Yes" ? "yes" : "no", selectedAns[0].body);
      }
      if (selectedAns && selectedAns.length > 0 && type == "singleChoice") {
        questionAnswers = this.widget.i18nActivities(`${this.currentQuestion.identifier}_options_${selectedAns[0].index}_body`) === false ? selectedAns && selectedAns[0].body : this.widget.i18nActivities(`${this.currentQuestion.identifier}_options_${selectedAns[0].index}_body`);
      }
      const questionData = {
        appLanguageId: this.portal.getLanguage(),
        createdTime: new Date(),
        deviceId: uuidv4(),
        displayLanguage: this.lang,
        displayQuestionAnswer: questionAnswers,
        displayQuestionBody: this.widget.i18nActivities(`${this.currentQuestion.identifier}_body`) === false ? body : this.widget.i18nActivities(`${this.currentQuestion.identifier}_body`),
        participantId: this.participantDetails.getParticipantID(),
        questionAnswer: selectedAns && selectedAns[0].body,
        questionBody: body,
        questionId: identifier,
        questionType: type,
        siteId: this.participantDetails.getSiteID() || this.getSiteID,
        studyId: this.portal.getStudy(),
        studyVersionId: this.portal.getVersion(),
        type: this.consent.currentConsentObj.config.dataVantConsent ? "datavant" : "econsent"
      };

      //Add new keys for Datavant Consent
      if(this.consent.currentConsentObj.config.dataVantConsent){
        let now = new Date();
        questionData.consentSignDate = moment.utc().valueOf();//UTC time in milliseconds
        questionData.consentSignLocalDate = moment(now).format("YYYY-MM-DDTHH:mm:ss.SSSZZ");
        questionData.participantOffset = moment(now).format("Z");
      }

      let index = this.onBoardingData.findIndex(
        (item) => item.questionId === questionData.questionId
      );
      if (index === -1) this.onBoardingData.push(questionData);
      else this.onBoardingData[index] = questionData;

      index = this.allQuizAns.findIndex(item => item.identifier === this.selectedQueAns.identifier);
      if (index === -1) {
        this.allQuizAns.push(this.selectedQueAns);
      } else {
        this.allQuizAns[index] = this.selectedQueAns;
      }
      this.selectedQueAns = null;
      this.nextButtonDisabled = true;
    },
    updateConsentValue(eventName, screen) {
      // save questions
      const saveQuestionPayload = {
        onBoardingData: this.onBoardingData
      };
      
      let apiMethod = this.consent.currentConsentObj.config.dataVantConsent ? 'participantSaveDatavantConsent' : 'participantSaveConsent';
      this.$api[apiMethod](this.getConsentID, saveQuestionPayload)
        .then( res => {
          if (res) {
            const message = this.widget.translate(res.message_key, res.message);
            if (message) {
              this.$toastr.success(message);
            }
            this.$emit(eventName, screen);
          }
        })
        .catch(() => {
          this.$emit(eventName, screen);
        });
    },
    agreed() {
      this.isParticipantAgreed = true;
      this.$emit("updateHeaderNav", { showBlankHeader: true, title: "Verify" });
    }
  }
};
</script>
<style lang="scss" scoped>
.av-education-boolean-question {
  .leavestudy,
  .leave_study_cntue {
    &:hover {
      background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
    }
    &:active {
      background-color: var(--primary) !important;
    }
  }
}
</style>
